import { isRejectedWithValue } from '@reduxjs/toolkit';
import type { Middleware } from '@reduxjs/toolkit';
import { toast } from 'sonner';

export const queryErrorLogger: Middleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    toast.error(`Error: ${action.payload.data.message ?? 'Something went wrong. Please, check the data.'}`);
  }

  return next(action);
};
